import { DefaultBGOperationsService, UuidIdGenerator } from '@prodcard/core'

export const bgOperationsService = new DefaultBGOperationsService({ idGenerator: new UuidIdGenerator() })
